"use client";

import { useEffect } from "react";
import { ErrorDisplay } from "./components/error-boundary/dds-error-display";
import { reportAppRouterBoundaryError } from "./components/error-boundary/report-app-router-error";

interface AppErrorProps {
  error: Error & { digest?: string };
  reset: () => void;
}

// DDS ErrorDisplay ships its own Refresh button that calls
// window.location.reload(). That's a heavier reset than App Router's
// reset() (re-render of the segment), but it matches the Page Router
// behavior at pages/_app.tsx and avoids forking DDS for an edge case.
export default function AppError({ error }: AppErrorProps) {
  useEffect(() => {
    reportAppRouterBoundaryError("AppRouterError", error);
  }, [error]);

  return (
    <ErrorDisplay
      hideCloseButton
      component="AppRouter"
      error={error}
    />
  );
}
